const VacancyApplicationsAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'shopping_center.title': i.vacancy?.shopping_center?.title,
    'users.id': i.user?.id,
    'users.surname': i.user?.hide_surname,
    'users.name': i.user?.hide_name,
    vacancy_application_type: i.vacancy.vacancy_application_type,
    vacancy_application_type_value: i?.vacancy?.vacancy_application_type?.title,
    experience_years: i?.user?.experience_years?.experience_year,
    region: i?.user?.region?.region,
    vacancy_language_level: i.user?.vacancy_language_level,
    vacancy_language2_level: i.user?.vacancy_language2_level,
    vacancy_language: i.user?.vacancy_language?.vacancy_language,
    vacancy_language2: i?.user?.vacancy_language2?.vacancy_language2,

    vacancy_category_title: i.vacancy?.vacancy_category?.title,
    'vacancies.company_id': i.vacancy?.company?.name,
    name: i.user?.name,
    email: i.user?.email,
    address: i.user?.address,
    surname: i.user?.surname,
    sex_short: i.user?.sex_short,
    years: i.user?.years,
    vacancy_title: i.vacancy?.title,
    vacancy_description: i?.vacancy?.description,
    vacancy_expired_at: i.vacancy?.expired_at,
    vacancy_type_title: i.vacancy?.vacancy_type?.title,
    cv: i.user?.cv,
    file: i.user?.file,
    birthday_range: i.user?.birthday_range,
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default VacancyApplicationsAdapter;
